import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../../redux/axios';

const initialState = {
  viewProcess: [],
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: '',
};

export const getProcess = createAsyncThunk(
  '/chd/api/template/',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      let response = await axios({
        url: `/api/chd/template/${udata}`,
        method: 'get',
        headers: {
          "Authorization": `Bearer ${tokenStr}`
        }
      })

      let data = response.data;
      if (response.status === 200) {
        return data;
      }
      else if (data.code === 200) {
        return data;
      }
      else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);




export const viewProcessSlice = createSlice({
  name: 'chdviewAllProcess',
  initialState,
  reducers: {
    clearStateProcess: (state, { payload }) => {
      //state.user = {};
      // state.isFetching = false;
      // state.isSuccess = false;
      state.isError = false;
      state.errorMessage = '';
    },
  },

  extraReducers: {
    [getProcess.fulfilled]: (state, { payload }) => {

      state.viewProcess = payload.data;
      state.isFetching = false;
      state.isSuccess = true;
      return state;
    },
    [getProcess.pending]: (state) => {
      state.isFetching = true;
    },
    [getProcess.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    }
  },
});

export const { clearStateProcess } = viewProcessSlice.actions;

export function clearState() {

  return async (dispatch) => {
    dispatch(clearStateProcess());
  }
}

export const viewProcessSelector = (state) => state.chdviewAllProcess;

export default viewProcessSlice.reducer;
